import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useCoreInput } from "@Shared/@Composables/inputs/useCoreInput";
import { computed, defineComponent, onMounted, toRefs } from "@vue/composition-api";
import { uniqueId } from "lodash";
import BaseLabel from "../base/base-label.vue";
import BaseInput from "../base/base-input.vue";
import { useInputMask } from "@Shared/@Composables/inputs/useInputMaks";
import BaseFieldLayout from "../base/base-field-layout.vue";
export default defineComponent({
  name: "CurrencyField",
  components: {
    BaseLabel,
    BaseInput,
    BaseFieldLayout
  },
  props: {
    value: {
      type: null,
      default: 0
    },
    id: {
      type: String,
      default: () => uniqueId()
    },
    name: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    validator: {
      type: Object,
      default: null
    },
    allowMinus: {
      type: Boolean,
      default: false
    },
    sideGrid: {
      type: Boolean,
      default: false
    },
    showRequiredIndicator: {
      type: Boolean,
      default: false
    },
    hiddenLabel: {
      type: Boolean,
      default: false
    },
    extraValidation: {
      type: Boolean,
      default: false
    }
  },
  setup(props, {
    emit
  }) {
    const {
      allowMinus,
      value,
      extraValidation
    } = toRefs(props);
    const {
      hasFocus,
      handleBaseFocus,
      handleBaseBlur,
      handleBaseChange,
      handleBaseInput,
      valueModel
    } = useCoreInput({
      value
    });
    const {
      buildCurrencyMask,
      currencyIconLeft
    } = useInputMask();
    const {
      inputMask
    } = buildCurrencyMask({
      allowMinus
    });
    const inputMaskForExtraValidations = computed(() => {
      return _objectSpread(_objectSpread({}, inputMask.value), {}, {
        alias: ""
      });
    });
    onMounted(() => {
      if (extraValidation.value && !valueModel.value) return emit("update:value", "");
      if (!valueModel.value) emit("update:value", 0);
    });
    return {
      valueModel,
      hasFocus,
      currencyIconLeft,
      handleBaseFocus,
      handleBaseBlur,
      handleBaseChange,
      handleBaseInput,
      inputMask,
      inputMaskForExtraValidations
    };
  }
});